import React from 'react';
import { Link } from 'react-router-dom';

import AuthUserContext from './AuthUserContext';
import SignOutButton from './SignOut';
import * as routes from '../constants/routes';
import * as layout from '../constants/layout';

import {Navbar, Icon} from 'react-materialize'


const Navigation = ({ authUser, history }) =>
      <AuthUserContext.Consumer>
          {authUser => authUser
            ? <NavigationAuth />
            : <NavigationNonAuth />
          }
      </AuthUserContext.Consumer>

const NavigationAuth = ({ history }) =>
  <div>
    <Navbar brand='Hotspot Engelsoft' right className={layout.NAV_CLASS}>
        <li>
            <Link to={routes.LANDING} ><Icon>search</Icon></Link>
        </li>
        <li>
            <Link to={routes.LANDING} >Landing</Link>
        </li>
        <li>
            <Link to={routes.HOME} >Home</Link>
        </li>
        <li>
            <Link to={routes.ACCOUNT} >Account</Link>
        </li>
        <SignOutButton />
    </Navbar>
  </div>
const NavigationNonAuth = () =>
  <Navbar brand='Hotspot Engelsoft' right className={layout.NAV_CLASS}>
    <li>
        <Link to={routes.TERMS} >Termos</Link>
    </li>
    <li>
        <Link to={routes.SIGN_IN}>Entrar</Link>
    </li>
  </Navbar>

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js